// extracted by mini-css-extract-plugin
module.exports = {"content":"distribute_agreement_popover_content__3TPAs","footer":"distribute_agreement_popover_footer__C_sEb"};